import { qspost} from '@/plugins/axios'
import {SZST_URL} from "@/config";

/*
 * 登录
 * */
export const login = (phone,password) => qspost('/api/Login/login', {phone,password})

/*
 * 手机短信快捷登陆
 * */
export const sms_login = (phone,code) => qspost('/api/Login/sms_login', {phone,code})

/*
 * 发送短信验证码
 * */
export const sendPhoneCode = (phone) => qspost('/api/Login/sendPhoneCode', {phone})

/*
 * 易魔方跳转登录
 * */
export const emof_login = (emofUserTokenSafer) => qspost('/api/Login/emof_login', {emofUserTokenSafer})

/*
 * 服务协议、隐私政策
 * */
export const getAgreement = () => qspost(SZST_URL + 'api/index/agreement', {})


